<template>
  <div
    id="userPreviewDetails"
    class="rm-scrollbar"
    style="width: 580px; line-height: normal"
  >
    <div class="flex-mid relative pt-35">
      <div style="position: absolute; top: 0px; left: 0px">
        <div
          v-if="userDetail.house && userDetail.house == '-LWPrZbcyHAVHIFUsWLd'"
        >
          <img class="house-seal-image" :src="getImgUrlMem('banner_corvus')" />
        </div>
        <div
          v-else-if="
            userDetail.house && userDetail.house == '-LWPrOElCYViBd6j6qP-'
          "
        >
          <img class="house-seal-image" :src="getImgUrlMem('banner_leonos')" />
        </div>
        <div
          v-else-if="
            userDetail.house && userDetail.house == '-LWOr-XsbZM2digYl1QL'
          "
        >
          <img
            class="house-seal-image"
            :src="getImgUrlMem('banner_delphinus')"
          />
        </div>
        <div v-else>
          <p class="houseSeal_1"></p>
          <p class="houseSeal_2"></p>
        </div>
      </div>
      <div v-if="userDetail.large_pic"
      :class="[ blurMode ?  'mega_blurelement': '' ]"
      @click="showProfilePhotoModal = true"
      class="profile-photo-container"
      >
        <img
          v-lazy="userDetail.large_pic"
          :key="userDetail.large_pic"
          style="object-fit: cover"
          class="image-skeleton image-profile-180 flex-mid profile-photo-clickable"
          :class="[ blurMode ?  'mega_blurelement': '' ]"
        />
        <div class="photo-overlay">
          <i class="el-icon-zoom-in"></i>
        </div>
      </div>
      <div v-else class="image image-profile-180 flex-mid"
      :class="[ blurMode ?  'mega_blurelement': '' ]">
        <div class="text-in-image text-in-image-180 flex-mid">
          {{
            $utils("acronymName", {
              firstName: userDetail.firstname,
              lastName: userDetail.lastname,
            })
          }}
        </div>
      </div>
      <div style="position: absolute; top: 0px; right: 0px">
        <div class="divCoin">
          <div
            style="
              padding-left: 8px;
              padding-bottom: 5px;
              display: flex;
              align-items: center;
            "
          >
            <img
              class="iconCoin"
              :src="$utils('icons', 'ic_profile_coin')"
              alt=""
            />
            <span class="txtCoin"
              >{{ $utils("addCommasInNumber", userDetail.coin || 0) }}
              {{ $t("members.coins") }}</span
            >
          </div>
          <div style="padding-left: 8px; display: flex; align-items: center">
            <img
              class="iconCoin"
              :src="$utils('icons', 'ic_profile_gem')"
              alt=""
            />
            <span class="txtCoin"
              >{{ $utils("addCommasInNumber", userDetail.gem || 0) }}
              {{ $t("members.gems") }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="flex-mid" style="padding-top: 10px">
      <div class="profile-name-container">
        <span
          v-if="userDetail.firstname || userDetail.lastname"
          class="txtProfileName"
          :class="[ blurMode ?  'mega_blurelement': '' ]"
          >{{ userDetail.firstname }}{{ userDetail.nickname ? ' (' + userDetail.nickname + ')' : '' }}{{ userDetail.lastname ? ' ' + userDetail.lastname : '' }}</span
        >
        <div v-else class="nullprofileName"></div>
        
        <!-- Personal Context Icon -->
        <div 
          v-if="personalContext"
          @click="showPersonalContextModal = true"
          class="personal-context-icon"
          title="View Personal Context"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
              <path d="M22 8v12c0 2.21-4.03 4-9 4s-9-1.79-9-4V8"/>
              <path d="M22 14c0 2.21-4.03 4-9 4s-9-1.79-9-4m18-6c0 2.21-4.03 4-9 4s-9-1.79-9-4s4.03-4 9-4s9 1.79 9 4m10-2h6a4 4 0 0 1 4 4v6M16 42h-6a4 4 0 0 1-4-4v-6"/>
              <circle cx="35" cy="29" r="5"/>
              <path d="M44 44H26a9 9 0 1 1 18 0"/>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div class="flex-mid mt-2">
      <span v-if="userDetail.dispteam" class="txtProfileTeamName"
      :class="[ blurMode ?  'mega_blurelement': '' ]">{{
        userDetail.dispteam
      }}</span>
      <div v-else class="nullprofileTeamName"></div>
    </div>

    <div v-if="userDetail['joined']" class="center mt-8">
      <div class="flex-mid">
        <el-tooltip effect="dark" placement="top">
          <div class="fs-11 mx-13" slot="content">
            {{ userDetail.joined_tooltips["year"] }}
            {{ $t("commponents.years") }},
            {{ userDetail.joined_tooltips["month"] }}
            {{ $t("commponents.months") }},
            {{ userDetail.joined_tooltips["day"] }}
            {{ $t("commponents.days_ago") }} ●
            {{ userDetail.joined_tooltips["percent"] }}%
            {{ $t("commponents.joined_after") }}
          </div>
          <div style="color: #2d2e36; font-weight: 300" class="flex">
            <img
              :src="$utils('icons', 'date_gray_12')"
              alt="icons_date_gray_12"
              style="width: 12px; height: 12px"
              class="mt-3 mr-4"
            />
            <div class="pb-2">
              {{ $t("commponents.joined") }} {{ userDetail["joined"] }}
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>

    <div class="flex-mid mt-8">
      <div class="div-active">
        <div class="btn-status" :class="[`status-${userDetail.status}`]">
          {{ userDetail.status }}
        </div>
        <div class="active">
          {{ userDetail.to_now ? userDetail.to_now : "&nbsp;" }}
        </div>
      </div>
    </div>



    <!-- Profile Photo Modal -->
    <div 
      v-if="showProfilePhotoModal" 
      class="custom-photo-modal"
      @click="handleBackdropClick"
      @keyup.esc="showProfilePhotoModal = false"
      tabindex="-1"
    >
      <div class="photo-modal-content" @click.stop>
        <!-- Close Button -->
        <div class="modal-close-button" @click="showProfilePhotoModal = false" title="Close">
          <i class="el-icon-close"></i>
        </div>
        
        <!-- Photo Container -->
        <div class="photo-container">
          <img
            :src="userDetail.large_pic"
            :alt="userDetail.firstname + ' ' + (userDetail.lastname || '')"
            class="fullscreen-photo"
          />
          <!-- Download Button -->
          <div class="download-button" @click="downloadPhoto" title="Download Photo">
            <i class="el-icon-download"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Personal Context Modal -->
    <el-dialog
      :visible.sync="showPersonalContextModal"
      title=""
      width="700px"
      :before-close="handleModalClose"
      custom-class="personal-context-modal"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
    >
      <div class="personal-context-content">
        <!-- Header -->
        <div class="context-header">
          <h3 class="fs-18 fw-700 fc-000000">{{ userDetail.firstname }}'s Personal Context</h3>
                     <p class="fs-13 fc-4A4A4A opa-08 context-subtitle">Analysis from communication patterns and feedback to understand them at a deeper level.</p>
        </div>

        <!-- Values Section -->
        <div v-if="personalContext && personalContext.values && personalContext.values.length" class="context-section">
          <div class="section-header">
            <i class="el-icon-star-on section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Personal Values</h4>
          </div>
          <div class="values-container">
            <span
              v-for="(value, index) in personalContext.values"
              :key="'value-' + index"
              class="value-tag"
            >
              {{ toProperCase(value) }}
            </span>
          </div>
        </div>

        <!-- Goals Section -->
        <div v-if="personalContext && personalContext.goals && personalContext.goals.length" class="context-section">
          <div class="section-header">
            <i class="el-icon-trophy section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Goals</h4>
          </div>
          <div class="goals-container">
            <div
              v-for="(goal, index) in personalContext.goals"
              :key="'goal-' + index"
              class="goal-item"
            >
              <div class="goal-number">{{ index + 1 }}</div>
              <div class="goal-text fs-14 fc-000000">{{ goal }}</div>
            </div>
          </div>
        </div>

        <!-- Skills Section -->
        <div v-if="personalContext && personalContext.skills && personalContext.skills.length" class="context-section">
          <div class="section-header">
            <i class="el-icon-medal section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Skills & Competencies</h4>
          </div>
          <div class="skills-container">
            <span
              v-for="(skill, index) in personalContext.skills"
              :key="'skill-' + index"
              class="skill-tag"
              :class="{ 'needs-improvement': skill.includes('needs improvement') }"
            >
              {{ toProperCase(skill.replace(' (needs improvement)', '')) }}
              <i v-if="skill.includes('needs improvement')" class="el-icon-warning-outline"></i>
            </span>
          </div>
        </div>

        <!-- Communication & Personality -->
        <div v-if="personalContext" class="context-section">
          <div class="section-header">
            <i class="el-icon-user section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Personality & Communication</h4>
          </div>
          <div class="personality-content">
            <div v-if="personalContext.personality" class="content-block">
              <div class="block-label fs-12 fw-600 fc-4A4A4A">PERSONALITY TRAITS</div>
              <div class="block-text fs-14 fc-000000">{{ toProperCaseWithSpacing(personalContext.personality) }}</div>
            </div>
            <div v-if="personalContext.communication_style" class="content-block">
              <div class="block-label fs-12 fw-600 fc-4A4A4A">COMMUNICATION STYLE</div>
              <div class="block-text fs-14 fc-000000">{{ toProperCaseWithSpacing(personalContext.communication_style) }}</div>
            </div>
          </div>
        </div>

        <!-- Professional Context -->
        <div v-if="personalContext && personalContext.general_info && personalContext.general_info.role_focus" class="context-section">
          <div class="section-header">
            <i class="el-icon-suitcase section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Role Focus</h4>
          </div>
          <div class="role-content">
            <div class="fs-14 fc-000000">{{ toProperCase(personalContext.general_info.role_focus) }}</div>
          </div>
        </div>

        <!-- Recent Challenges -->
        <div v-if="personalContext && personalContext.recent_challenges && personalContext.recent_challenges.length" class="context-section">
          <div class="section-header">
            <i class="el-icon-warning section-icon"></i>
            <h4 class="fs-15 fw-700 fc-000000">Recent Challenges</h4>
          </div>
          <div class="challenges-content">
            <div 
              v-for="(challenge, index) in personalContext.recent_challenges" 
              :key="'challenge-' + index"
              class="challenge-item"
            >
              <div class="challenge-bullet"></div>
              <div class="challenge-text fs-14 fc-000000">{{ challenge }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="mx-auto">
      <div
        v-if="userDetail.introduce"
        class="max-width-mobile mx-auto fc-000000"
      >
        <div class="fs-14 fw-700 ml-18 flex-center">
          Activity Timeline
        </div>
      </div>
      <div
        v-if="
          (modalMemberData['from'] &&
            modalMemberData['from'] == 'members' &&
            riskDataMembers) ||
          riskData
        "
        class="risk-container flex-center"
      >
        <!-- Happiness Timeline Icon -->
        <el-tooltip
          placement="right"
          trigger="hover"
          :open-delay="300"
          effect="light"
          popper-class="happiness-history-tooltip"
          :hide-after="0"
          :append-to-body="true"
          :offset="10"
        >
          <template slot="content">
            <div v-if="loadingHappinessPatterns[userDetail.email]" class="happiness-loading">
              <i class="el-icon-loading"></i> Loading happiness data...
            </div>
            <div v-else-if="happinessPatterns[userDetail.email] && happinessPatterns[userDetail.email].error" class="happiness-error">
              {{ happinessPatterns[userDetail.email].error }}
            </div>
            <div v-else-if="happinessPatterns[userDetail.email]" class="happiness-tooltip-content">
              <div class="happiness-tooltip-header">
                <div class="tooltip-title">90-Day Happiness History</div>
                <div class="tooltip-subtitle">{{ userDetail.firstname }}'s recent happiness</div>
              </div>
              
              <div class="happiness-stats">
                <div class="stat-item">
                  <span class="stat-dot green"></span>
                  <span class="stat-label">Happy:</span>
                  <span class="stat-value">{{ happinessPatterns[userDetail.email].stats.happyDays }} days ({{ happinessPatterns[userDetail.email].stats.happyPercentage }}%)</span>
                </div>
                <div class="stat-item">
                  <span class="stat-dot yellow"></span>
                  <span class="stat-label">Okay:</span>
                  <span class="stat-value">{{ happinessPatterns[userDetail.email].stats.okayDays }} days ({{ happinessPatterns[userDetail.email].stats.okayPercentage }}%)</span>
                </div>
                <div class="stat-item">
                  <span class="stat-dot red"></span>
                  <span class="stat-label">Not Great:</span>
                  <span class="stat-value">{{ happinessPatterns[userDetail.email].stats.notGreatDays }} days ({{ happinessPatterns[userDetail.email].stats.notGreatPercentage }}%)</span>
                </div>
              </div>
              
              <!-- Recovery Flags Summary -->
              <div v-if="happinessPatterns[userDetail.email].hasRecoveryData && happinessPatterns[userDetail.email].recoveryFlags.length > 0" class="recovery-flags-summary">
                <div class="recovery-header">
                  <div class="recovery-title">Recovery Progress</div>
                  <div class="recovery-subtitle">{{ happinessPatterns[userDetail.email].recoveryFlags.length }} positive indicator(s) noted</div>
                </div>
                <div class="recovery-flags-list">
                  <div 
                    v-for="(flag, index) in happinessPatterns[userDetail.email].recoveryFlags.slice(0, 3)" 
                    :key="index"
                    class="recovery-flag-item"
                  >
                    <span class="recovery-flag-date">{{ flag.date }}</span>
                    <span class="recovery-flag-level recovery">
                      +
                    </span>
                    <span class="recovery-flag-content">{{ flag.content && flag.content !== 'undefined' ? flag.content : 'Recovery detected' }}</span>
                  </div>
                  <div v-if="happinessPatterns[userDetail.email].recoveryFlags.length > 3" class="more-flags">
                    ... and {{ happinessPatterns[userDetail.email].recoveryFlags.length - 3 }} more recovery indicators
                  </div>
                </div>
              </div>

              <!-- Risk Flags Summary -->
              <div v-if="happinessPatterns[userDetail.email].hasRiskData && happinessPatterns[userDetail.email].riskFlags.length > 0" class="risk-flags-summary">
                <div class="risk-header">
                  <div class="risk-title">Risk Flags Summary</div>
                  <div class="risk-subtitle">{{ happinessPatterns[userDetail.email].riskFlags.length }} risk flag(s) detected</div>
                </div>
                <div class="risk-flags-list">
                  <div 
                    v-for="(flag, index) in happinessPatterns[userDetail.email].riskFlags.slice(0, 3)" 
                    :key="index"
                    class="risk-flag-item"
                  >
                    <span class="risk-flag-date">{{ flag.date }}</span>
                    <span class="risk-flag-level" :class="getRiskFlagClass(flag.highlight)">
                      {{ flag.highlight === 'R' ? '!' : flag.highlight === '2R' ? '!!' : '!!!' }}
                    </span>
                    <span class="risk-flag-content">{{ flag.content && flag.content !== 'undefined' ? flag.content : 'Risk detected' }}</span>
                  </div>
                  <div v-if="happinessPatterns[userDetail.email].riskFlags.length > 3" class="more-flags">
                    ... and {{ happinessPatterns[userDetail.email].riskFlags.length - 3 }} more risk flags
                  </div>
                </div>
              </div>
              
              <div class="happiness-timeline">
                <div class="timeline-label">Recent Timeline (oldest to newest):</div>
                <div class="timeline-months">
                  <div 
                    v-for="(monthData, monthKey) in happinessPatterns[userDetail.email].monthlyData" 
                    :key="monthKey"
                    class="timeline-month"
                  >
                    <div class="month-label">{{ monthData.monthName }}</div>
                    <div class="month-grid">
                      <div 
                        v-for="(day, dayIndex) in monthData.days" 
                        :key="dayIndex"
                        class="timeline-day"
                        :class="day.response || 'no-response'"
                        :title="`${day.formattedDate} (${day.dayOfWeek}): ${day.response ? (day.response === 'green' ? 'Happy' : day.response === 'yellow' ? 'Okay' : 'Not Great') : 'No response'}${day.riskFlag && day.riskFlag.highlight ? ' | Risk: ' + day.riskFlag.highlight : ''}${day.recoveryFlag ? ' | Recovery indicator' : ''}`"
                      >
                        <span class="day-number">{{ day.dayOfMonth }}</span>
                        <div v-if="day.riskFlag && day.riskFlag.highlight && day.riskFlag.highlight.includes('R')" class="risk-flag">
                          {{ day.riskFlag.highlight === 'R' ? '!' : day.riskFlag.highlight === '2R' ? '!!' : '!!!' }}
                        </div>
                        <div v-if="day.recoveryFlag" class="recovery-flag">
                          +
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="timeline-legend">
                  <span class="legend-item"><span class="legend-dot no-response"></span>No response</span>
                  <span class="legend-item"><span class="legend-dot green"></span>Happy</span>
                  <span class="legend-item"><span class="legend-dot yellow"></span>Okay</span>
                  <span class="legend-item"><span class="legend-dot red"></span>Not Great</span>
                </div>
              </div>
            </div>
            <div v-else class="happiness-loading">
              Hover to load happiness data
            </div>
          </template>
          <i 
            class="el-icon-s-data happiness-timeline-icon mr-8"
            @mouseenter="handleHappinessHover"
            title="View 90-day happiness journey with risk & recovery insights"
          ></i>
        </el-tooltip>
        
        <div
          @click="loadMoreData"
          style="width: 32px"
          class="back-button flex-mid fs-16 cursor-pointer"
        >
          <i
            v-if="
              (modalMemberData['from'] &&
                modalMemberData['from'] == 'members' &&
                !loadingLoadMoreDataMembers) ||
              (!modalMemberData['from'] && !loadingLoadMoreData)
            "
            class="el-icon-arrow-left"
          ></i>
          <i v-else class="el-icon-loading"></i>
        </div>
        <div
          v-dragscroll
          id="riskBox"
          class="flex-center thin-scrollbar risk-box-grab cursor-grab"
        >
          <div
            v-for="(risk, index) in modalMemberData['from'] &&
            modalMemberData['from'] == 'members' &&
            riskDataMembers
              ? riskDataMembers
              : riskData"
            :key="'risk_data_' + index"
          >
            <div v-if="risk.day == 'Sat'" class="risk-line-breaking">
              &nbsp;
            </div>
            <div :class="`risk-status ${risk.status} flex-mid`">
              <div class="relative" v-if="risk.status">
                <div
                  v-if="
                    risk.highlight == 'S' ||
                    risk.highlight == 'S&R' ||
                    risk.highlight == 'S&2R' ||
                    risk.highlight == 'S&3R'
                  "
                  class="highlight"
                >
                  <div
                    v-if="
                      risk.highlight == 'S&R' ||
                      risk.highlight == 'S&2R' ||
                      risk.highlight == 'S&3R'
                    "
                    :class="`pop-up-red ${
                      risk.highlight == 'S&R'
                        ? 'red-1'
                        : risk.highlight == 'S&2R'
                        ? 'red-2'
                        : 'red-3'
                    }`"
                  >
                    <div
                      class="ml-auto cursor-pointer"
                      :style="`width: ${
                        risk.highlight == 'S&R'
                          ? '4'
                          : risk.highlight == 'S&2R'
                          ? '7'
                          : '10'
                      }px;`"
                    >
                      <el-tooltip placement="top">
                        <div slot="content" class="fw-400 fs-11" v-html="risk.highlightContent"></div>
                        <div class="fw-700 fs-12">
                          {{
                            risk.highlight == "S&R"
                              ? "!"
                              : risk.highlight == "S&2R"
                              ? "!!"
                              : "!!!"
                          }}
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="pop-up flex-mid">
                    <el-tooltip placement="top">
                      <div slot="content" class="fw-400 fs-11">
                        Star performance from being in the top 15% of people who received recognition that week
                      </div>
                      <img
                        style="width: 12px; height: 12px"
                        :src="$utils('icons', 'ic_star_24px')"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </div>
                <div
                  v-else-if="
                    risk.highlight == 'R' ||
                    risk.highlight == '2R' ||
                    risk.highlight == '3R'
                  "
                  class="highlight"
                >
                  <div class="pop-up risk flex-mid">
                    <el-tooltip placement="top">
                      <div slot="content" class="fw-400 fs-11">
                        {{ risk.highlightContent }}
                      </div>
                      <div
                        class="fw-700 fs-12 fc-FFFFFF center cursor-pointer"
                        style="padding-top: 3px; width: 14px"
                      >
                        {{
                          risk.highlight == "R"
                            ? "!"
                            : risk.highlight == "2R"
                            ? "!!"
                            : "!!!"
                        }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="relative last">
          <div class="right label fw-700 fs-10">
            <div style="width: 80px">{{ $t("commponents.MOST_RECENT") }}</div>
          </div>
        </div>
      </div>
      <div v-else class="risk-container flex-mid">
        <div class="fs-14 fw-06 flex-mid opa-05" style="height: 92px">
          No recent data
        </div>
      </div>
    </div>

    <div
      v-if="userDetail.medal && Object.keys(userDetail.medal).length"
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="fs-14 fw-700 ml-18">Medals</div>
      
        <div class="medals-container flex-center disable-scrollbar cursor-grab"
        style="display: -webkit-box;"
          v-dragscroll
          >
          <div
            class="mx-5"
            :key="index"
            v-for="(name, index) in userDetail.medal"
          >
            <div v-if="name.image&&name" style="display: flex;justify-items: center;flex-direction: column; align-items: center;">
              <img :src="getImgUrlSetNew(name.image)" class="img-medal" />
              <p class="fw-700 fc-FBC02D fs-10 m-0 ellipsis" >{{ name.en }}</p>
            </div>
            <div v-else>
              <img :src="getImgUrlSet(`${index}-on@3x`)" class="img-medal" />
              <p class="fw-700 fc-FBC02D fs-10 m-0 ellipsis">{{ index }}</p>
            </div>
          </div>
        </div>
      
    </div>

    <div
      v-if="
        modalMemberData['leaderboard'] && modalMemberData['leaderboard'].length
      "
      class="fc-000000"
    >
      <div class="max-width-mobile mx-auto">
        <div class="fs-14 fw-700 ml-18">Leaderboards</div>
      </div>
      <div
        v-dragscroll
        class="leaderboards-container disable-scrollbar mt-12 pb-8 cursor-grab"
      >
        <div
          class="flex-center"
          style="width: fit-content; padding-left: 120px"
        >
          <div
            v-for="(valueLeader, index) in modalMemberData['leaderboard']"
            :key="valueLeader.id + '_' + index"
            class="box-content"
            :class="valueLeader.id"
          >
            <div class="icons-header">
              <img
                :src="$utils('icons', retrunImage(valueLeader.id))"
                :alt="valueLeader.key"
                style="width: 20px; height: 20px"
              />
            </div>
            <div class="fs-16 fw-700 mt-5">
              {{ valueLeader.value }}
            </div>
            <div class="fs-12 mt-7" style="font-family: Georgia">
              {{ setOrdinalSuffix(valueLeader.rank_month) }} /
              {{ setOrdinalSuffix(valueLeader.rank_all) }}
            </div>
            <div class="fs-11 opa-05 mt-2">{{ valueLeader.key }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        modalMemberData['topskill'] && modalMemberData['topskill'].length > 0
      "
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="mx-18 mt-16">
        <div class="flex mb-12">
          <div class="fs-14 fw-700">Top Skills</div>
          <div class="fs-12 opa-04 ml-12 mt-2">
            unique peer feedback endorsements
          </div>
        </div>
        <div
          v-for="(data, index) in modalMemberData['topskill']"
          :key="index + data.key + '_skill_'"
        >
          <div
            v-if="showMoreTopSkill ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_on')"
                  alt="skill_on"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_off')"
                  alt="skill_off"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_on')"
                  alt="skill_on"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text top-skill mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!showMoreTopSkill && modalMemberData['topskill'].length > 5"
          class="mb-26"
        >
          <span @click="showMoreTopSkill = true" class="view-all"
            >View all</span
          >
        </div>
      </div>
    </div>
    <div
      v-if="
        modalMemberData['cultureAdd'] &&
        modalMemberData['cultureAdd'].length > 0
      "
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="mx-18 mt-24">
        <div class="flex mb-12">
          <div class="fs-14 fw-700">Culture Add</div>
          <div class="fs-12 opa-04 ml-12 mt-2">
            contributions to recognition #values
          </div>
        </div>





      <div>
        
        <div
          v-dragscroll
          id="riskBox"
          class="flex-center disable-scrollbar cursor-grab"
          style="display: -webkit-box;  height: 40px;"
        >
          <div
            v-for="(value) in recognitionValue"
            :key="value.value + '_input'"
          >
          <div style=" height: 27px;">
            <span @click="setRecognition(value.label)"  :class="setClassRecognition(value.label)?'reconigtion-tags-selected center fs-13':'reconigtion-tags center fs-13'" >{{ value.label}} ({{ hashtag[value.label]}})</span>
          </div>
          </div>
        </div>
       
      </div>
      

       
    
        <div
          v-for="(data, index) in modalMemberData['cultureAdd']"
          :key="index + data.key + '_skill_'"
        >
        <div v-if="selectRecognition==data.key">
          <div
            v-if="showMoreCultureAdd ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_10_14dp')"
                  alt="add_purple_10_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text culture-add mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectRecognition=='All'">
          <div
            v-if="showMoreCultureAdd ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_10_14dp')"
                  alt="add_purple_10_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text culture-add mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        </div>


        <div class="recognition flex-center" style=" height: 56px; border-radius: 4px;" >
          <template >
                      <div class="flex-between "  style=" width:296px;">
                          <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderGiven,recognition.count_given_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                           
                          <div class="ranking">
                              <span class="label fs-11 flex-mid" style="width: 32px">{{
                              recognition.orderGiven
                              }}</span>
                          </div>
                          <div class="flex-column ml-12">
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Recognition Given"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.given}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right"> {{ recognition.alignmentGiven}}</span>
                          </div>
                       
                      </div>
          </template>

        </div>

        
        <div class="recognition flex-center" style=" height: 56px; margin-top: 12px; border-radius: 4px;">
          <template >
                      <div class="flex-between "  style=" width:296px;">
                        <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderReceived,recognition.count_received_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                           
                          <div class="ranking">
                              <span class="label fs-11 flex-mid fs-11" style="width: 32px">{{
                              recognition.orderReceived
                              }}</span>
                          </div>
                          <div class="flex-column ml-12">
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Recognition Received"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 ">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.received}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right">{{
                              recognition.alignmentReceived }}</span>
                          </div>
                      </div>
                  </template>

        </div>

        
        <div class="recognition flex-center" style=" height: 56px; margin-top: 12px; border-radius: 4px;">
          <template >
                      <div class="flex-between "  style=" width:296px;">
                          <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderRatio,recognition.count_ratio_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                          <div class="ranking">
                              <span class="label fs-11 flex-mid" style="width: 32px">{{
                               recognition.orderRatio
                              }}</span>
                          </div>
                          <div class="flex-column ml-12" >
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Give-to-receive Ratio"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 ">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.ratio}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right">{{
                              recognition.alignmentRatio }}</span>
                          </div>
                      </div>
                  </template>

        </div>


        <div
          v-if="!showMoreCultureAdd && modalMemberData['cultureAdd'].length > 5"
          class="mb-26"
        >
          <span @click="showMoreCultureAdd = true" class="view-all"
            >View all</span
          >
        </div>
        <div class="fs-12 pt-8" style="color: #5f32a7"
        :class="[ blurMode ?  'blurelement': '' ]">
          {{ userDetail.firstname }} is a top
          {{ userDetail.culture_add_percentile }}% culture add contributor
        </div>
      </div>
    </div>

    <div
      class="flex-mid tabs-112"
      style="padding-top: 8px; padding-bottom: 32px"
    >
      <el-tabs id="tabHeaderStyle" v-model="activeTab">
        <el-tab-pane label="powers" name="powers" default>
          <span slot="label" class="tabsTitle">{{
            $t("commponents.power")
          }}</span>
          <div>
            <div
              v-for="data in powerData"
              :key="data.label + '_bar'"
              class="power-tabs flex-center"
              :class="`power-${data.icon}`"
            >
              <div class="rating-box flex-mid">
                <span class="px-4">{{ data.rating !== undefined ? data.rating : '-' }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="star_black_24dp"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="pb-2"
                >
                  <g id="Group_13402" data-name="Group 13402">
                    <path
                      id="Path_5306"
                      data-name="Path 5306"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_5307"
                      data-name="Path 5307"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_13403"
                    data-name="Group 13403"
                    transform="translate(2.295 2.382)"
                    :fill="matchingColorWidthName(data.icon)"
                  >
                    <path
                      id="Path_5308"
                      data-name="Path 5308"
                      d="M9.148,12.7l2.767,1.673a.665.665,0,0,0,.993-.72l-.733-3.147,2.447-2.12a.665.665,0,0,0-.38-1.167l-3.22-.273L9.761,3.978a.667.667,0,0,0-1.227,0L7.274,6.944l-3.22.273a.665.665,0,0,0-.38,1.167L6.121,10.5l-.733,3.147a.665.665,0,0,0,.993.72Z"
                      transform="translate(-3.443 -3.573)"
                    />
                  </g>
                </svg>
              </div>
              <div
                :class="`color-bar`"
                :style="`width: ${setBarWidth(data.value, data.maxValue)}px;`"
              ></div>
              <div class="icon-container">
                <img
                  class="icon absolute-mid"
                  :src="getImgIconOfPower(data.icon)"
                  :alt="data.icon"
                />
                <!-- <div class="text-value absolute-mid">
                  <span>{{
                    $utils("powerBreakingPoint", data.value).label
                  }}</span
                  ><span class="fs-11">{{
                    $utils("powerBreakingPoint", data.value).unit
                  }}</span>
                </div> -->
              </div>
              <div class="relative">{{ data.label }}</div>
              <div class="ml-auto mr-16 relative">
                {{ $utils("addCommasInNumber", data.value || 0) }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="badges" name="Badges">
          <span slot="label" class="tabsTitle">{{ $t('commponents.badges') }}</span>
          <div
            v-if="userDetail.status !== 'new'"
            class="divContentProfileModal"
          >
            <div
              v-if="!modalMemberData['achievements']"
              class="center pt-40 mt-40"
            >
              <loading-even></loading-even>
            </div>
            <div
              class="rowDataSkillStyle"
              :key="index"
              v-for="(item, index) in modalMemberData['achievements']"
            >
              <div style="padding-left: 20px; width: 65%">
                <span class="fc-4A4A4A fs-16">{{ item.name }}</span>
              </div>
              <div style="display: flex; padding-right: 20px; width: 35%">
                <div v-for="i in 6" :key="item.name + '_' + i">
                  <div v-if="i <= item.count" class="curcleUnlock"></div>
                  <div v-else class="curcleLock"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="userDetail.status !== 'new'"
              class="divContentProfileModal"
            >
              <div
                class="rowDataSkillStyle"
                :key="index"
                v-for="(item, index) in modalMemberData['achievements']"
              >
                <div style="padding-left: 20px; width: 65%">
                  <span class="fc-4A4A4A fs-16">{{ item.name }}</span>
                </div>
                <div style="display: flex; padding-right: 20px; width: 35%">
                  <div v-for="i in 6" :key="item.name + '_' + i">
                    <div v-if="i <= item.count" class="curcleUnlock"></div>
                    <div v-else class="curcleLock"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="divContentProfileModal">
              <div
                v-for="text in [
                  'Initiative',
                  'Contributor',
                  'Leadership',
                  'Health',
                ]"
                :key="text"
                class="rowDataSkillStyle"
              >
                <div style="padding-left: 20px; width: 65%">
                  <span class="fc-4A4A4A fs-16">{{ text }}</span>
                </div>
                <div style="display: flex; padding-right: 20px; width: 35%">
                  <div
                    v-for="index in [1, 2, 3, 4, 5, 6]"
                    :key="index"
                    class="curcleLock"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="Org" name="org">
          <span slot="label" class="tabsTitle">{{
            $t("commponents.org")
          }}</span>
          <org-tab v-if="orgChartData" :orgData="orgChartData" />
        </el-tab-pane>
        <el-tab-pane label="Relationships" name="relationships">
          <span slot="label" class="tabsTitle">{{
            $t("commponents.relationships")
          }}</span>
          <relationship-mapping
            v-if="reladingRelationshipStatus"
            :modalMemberData="modalMemberData"
            :profile="relationshipData"
          />
        </el-tab-pane>
              </el-tabs>
      </div>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";
import { globalfunc } from "../../globalfunc";
import firebase from 'firebase/app';
import 'firebase/firestore';
import format from 'date-fns/format';
export default {
  directives: {
    dragscroll,
  },
  name: "modal-preview-user",
  components: {
    loadingEven: require("@/components/even/loading").default,
    relationshipMapping:
      require("@/components/members/members-components/relationship-mapping")
        .default,
    orgTab: require("@/components/members/members-components/org").default,
  },
  props: [
    "userDetail",
    "passProfileToRelationship",
    "orgChartData",
    "powerData",
    "modalMemberData",
    "relationshipData",
  ],
  data() {
    return {
      orgData: [],
      activeTab: "powers",
      showMoreTopSkill: false,
      showMoreCultureAdd: false,
      reladingRelationshipStatus: true,
      selectRecognition:'All',
      expandedPersonalContext: false,
      personalContextData: null,
      showPersonalContextModal: false,
      showProfilePhotoModal: false,
      // Happiness History Data
      happinessPatterns: {},          // Store happiness data for users
      loadingHappinessPatterns: {},   // Track loading states
    };
  },
  computed: {
    riskData() {
      return this.$store.getters["people/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["people/loadingLoadMoreData"];
    },
    riskDataMembers() {
      return this.$store.getters["newmember/riskData"];
    },
    loadingLoadMoreDataMembers() {
      return this.$store.getters["newmember/loadingLoadMoreData"];
    },

    recognition(){
        return this.$store.getters["newmember/recognition"];
    },
    alignment(){
        return this.$store.getters["newmember/alignment"];
    },
    hashtag(){
        return this.$store.getters["newmember/hashtag"];
    },
    recognitionValue(){
        return this.$store.getters["newmember/recognitionValue"];
    },
    last_rank_given(){
        return this.$store.getters["newmember/last_rank_given"];
    },
    last_rank_received(){
        return this.$store.getters["newmember/last_rank_received"];
    },
    last_rank_ratio(){
      return this.$store.getters["newmember/last_rank_ratio"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    personalContext() {
      return this.$store.getters["newmember/personalContext"];
    },
  },
  mounted() {
    this.reladingRelationshipStatus = false;
    setTimeout(() => {
      var container = this.$el.querySelector("#riskBox");
      container.scrollLeft = container.scrollWidth;
      this.reladingRelationshipStatus = true;
    }, 1000);
    
    this.personalContextData = this.modalMemberData['personal_context'];
    
    // Add ESC key listener
    document.addEventListener('keyup', this.handleEscKey);
  },
  beforeDestroy() {
    // Remove ESC key listener
    document.removeEventListener('keyup', this.handleEscKey);
  },
  methods: {
    toProperCase(text) {
      if (!text) return '';
      return text.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    },
    formatCommaSeparated(text) {
      if (!text) return '';
      // Split by comma, trim each item, and rejoin with comma and space
      return text.split(',').map(item => item.trim()).join(', ');
    },
    toProperCaseWithSpacing(text) {
      if (!text) return '';
      // First ensure proper spacing after commas, then apply proper case
      const withSpacing = this.formatCommaSeparated(text);
      return this.toProperCase(withSpacing);
    },
    setRecognition(value){
        this.selectRecognition=value
        // console.log('value',value)
        this.$store.dispatch("newmember/filtersReconition", value);

        
    },
    setClassRecognition(value){
        if(this.selectRecognition == value){
            return true;
        }else{
            return false;
        }
    },
    setOrdinalSuffix(i) {
      return globalfunc.ordinal_suffix_of(i);
    },
    getImgUrlMem(pic) {
      var images = require.context("@/assets/images/members/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "@/assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrlSetNew(url) {
      if(url.includes('Charisma')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCharisma-on%403x.png?alt=media&token=e4172468-60cd-4f49-827e-ef090c0c2802"

      }else if(url.includes('Creativity')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCreativity-on%403x.png?alt=media&token=104dbd9c-d13c-460a-8ac8-fe930391740d"

      }else if(url.includes('Initiative')){
        return 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FInitiative-on%403x.png?alt=media&token=702fcdda-4fea-4d1d-a85b-5e1ed5e8f7e7'
      }else if(url.includes('Intelligence')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FIntelligence-on%403x.png?alt=media&token=06327c99-b89b-4d0a-907d-d2d4fab4489d"
        
      }else if(url.includes('Kindness')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FKindness-on%403x.png?alt=media&token=fb934cc6-4437-4cd9-bb65-6688667b72c7"
        
      }else if(url.includes('Strength')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FStrength-on%403x.png?alt=media&token=f673ba77-ec00-4fe7-b49d-dbdea2fc19e5"
      }

     
    },
    retrunImage(value) {
      if (value == "recog_count") {
        return "sup_recog_icon@2x";
      } else if (value == "streak_count") {
        return "daily_streak_icon@2x";
      } else if (value == "super_feedback_count") {
        return "sup_feedback_icon@2x";
      } else if (value == "ps_initiative_making") {
        return "initiative_icon@2x";
      } else if (value == "ps_critical_thinking") {
        return "cri_thinking_icon@2x";
      } else if (value == "ps_self_awareness") {
        return "self_awareness_icon@2x";
      } else if (value == "ps_empathy") {
        return "empathy_icon@2x";
      } else if (value == "ps_optimism") {
        return "Optimism_icon@2x";
      } else if (value == "ps_leadership") {
        return "leadership_icon@2x";
      }
      return "";
    },
    loadMoreData() {
      if (
        this.modalMemberData["from"] &&
        this.modalMemberData["from"] == "members"
      ) {
        this.$store.dispatch("newmember/getDailyStatus", this.userDetail);
      } else {
        this.$store.dispatch("people/getDailyStatus", this.userDetail);
      }
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = ((337 - 70) / 100) * percentage;
      return width || "0";
    },
    setBarWidthRecognition(value, max) {
      if (!value || typeof value !== 'string') {
        return "0";
      }
      const _val=value.slice(0,(value.length-2))
      let percentage = ( max - ( parseInt(_val) - 1)) / (max)
      let width =((296) * percentage)
      return width || "0";
    },
    matchingColorWidthName(icon) {
      if (!icon) return "";
      const array = [
        {
          icon: "ic_empathy",
          color: "#6000da",
        },
        {
          icon: "ic_selfawareness",
          color: "#f77511",
        },
        {
          icon: "ic_criticalthinking",
          color: "#ff2b19",
        },
        {
          icon: "ic_leadership",
          color: "#00AA1A",
        },
        {
          icon: "ic_initiative",
          color: "#8CE100",
        },
        {
          icon: "ic_optimism",
          color: "#F2D222",
        },
      ];
      const color = array.find((item) => item.icon === icon);
      return color ? color.color : "";
    },
    getContextPreview() {
      if (this.personalContext) {
        const items = [];
        if (this.personalContext.values && this.personalContext.values.length) {
          items.push(...this.personalContext.values.slice(0, 3));
        }
        if (this.personalContext.skills && this.personalContext.skills.length && items.length < 3) {
          const skillsToAdd = this.personalContext.skills.slice(0, 3 - items.length);
          items.push(...skillsToAdd.map(skill => skill.replace(' (needs improvement)', '')));
        }
        return items.length > 0 ? items.join(', ') + '...' : 'View personal context details';
      }
      return '';
    },
    handleModalClose() {
      this.showPersonalContextModal = false;
    },
    handleBackdropClick() {
      this.showProfilePhotoModal = false;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.showProfilePhotoModal) {
        this.showProfilePhotoModal = false;
      }
    },
    async downloadPhoto() {
      if (!this.userDetail.large_pic) return;
      
      try {
        // Create a proxy URL to handle CORS issues
        const proxyUrl = this.userDetail.large_pic;
        
        // Try to fetch the image
        const response = await fetch(proxyUrl, {
          mode: 'cors',
          credentials: 'omit'
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.style.display = 'none';
        
        // Get file extension from the original URL or default to jpg
        const urlParts = this.userDetail.large_pic.split('.');
        const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
        
        const fileName = `${this.userDetail.firstname}${this.userDetail.lastname ? '_' + this.userDetail.lastname : ''}_profile_photo.${extension}`;
        link.download = fileName;
        
        // Force download attribute
        link.setAttribute('download', fileName);
        
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
        
      } catch (error) {
        console.error('Error downloading photo:', error);
        
        // Enhanced fallback: Try to force download using a different approach
        try {
          const link = document.createElement('a');
          link.href = this.userDetail.large_pic;
          link.download = `${this.userDetail.firstname}${this.userDetail.lastname ? '_' + this.userDetail.lastname : ''}_profile_photo`;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (fallbackError) {
          console.error('Fallback download failed:', fallbackError);
          // Last resort: open in new tab
          window.open(this.userDetail.large_pic, '_blank');
        }
      }
    },
    /**
     * Handle happiness hover event
     */
    handleHappinessHover() {
      if (!this.userDetail || !this.userDetail.email) {
        return;
      }
      
      this.loadUserHappiness(this.userDetail);
    },
    /**
     * Check if a date is a company holiday
     * @param {string} dateStr - Date in YYYY-MM-DD format
     * @returns {boolean} - True if the date is a holiday
     */
    isHoliday(dateStr) {
      const settingData = this.$store.getters['settings/settingData'];
      if (!settingData || !settingData.holiday_val || settingData.holiday_val.length === 0) {
        return false;
      }
      
      const checkDate = new Date(dateStr);
      return settingData.holiday_val.some(holidayDate => {
        const holiday = new Date(holidayDate);
        return holiday.getFullYear() === checkDate.getFullYear() &&
               holiday.getMonth() === checkDate.getMonth() &&
               holiday.getDate() === checkDate.getDate();
      });
    },
    /**
     * Loads happiness data for active users to display in hover tooltip
     * Shows 90 days of happiness responses from current date backwards
     * @param {Object} user - The user object containing email and other details
     */
    async loadUserHappiness(user) {
      // Check if data is already loaded or currently loading
      if (this.happinessPatterns[user.email] || this.loadingHappinessPatterns[user.email]) {
        return;
      }
      
      // Set loading state
      this.$set(this.loadingHappinessPatterns, user.email, true);
      
      try {
        // Calculate date range: 90 days from current date backwards
        const endDate = format(new Date(), 'YYYY-MM-DD');
        const startDate = format(new Date(Date.now() - (90 * 24 * 60 * 60 * 1000)), 'YYYY-MM-DD');
        
        const happinessRef = firebase.firestore()
          .collection('users_questions')
          .where('users', '==', user.email)
          .where('quest_id', '==', '-Kgs61AHOnpJ3rfyQr6t') // Happiness question ID
          .where('date', '>=', startDate)
          .where('date', '<=', endDate)
          .orderBy('date', 'desc');
          
        let happinessSnapshot;
        let riskSnapshot = { forEach: () => {}, empty: true, size: 0 };
        
        try {
          // Execute happiness query (primary)
          happinessSnapshot = await happinessRef.get().catch(err => {
            return { forEach: () => {}, empty: true };
          });
          
          // Query risk data from Firebase (optional - graceful fallback if fails)
          try {
            const riskRef = firebase.firestore()
              .collection('report_weekly_risk_all')
              .where('email', '==', user.email)
              .where('date', '>=', startDate)
              .where('date', '<=', endDate)
              .orderBy('date', 'desc');
              
            riskSnapshot = await riskRef.get();
          } catch (riskError) {
            console.log('riskError',riskError)
            // Continue without risk data - not critical for functionality
          }
        } catch (queryError) {
          throw queryError;
        }
        // // Get existing risk data from store
        // // console.log(this.modalMemberData['from'])
        // // console.log(this.riskDataMembers)
        // const riskData = this.modalMemberData['from'] && this.modalMemberData['from'] === 'members' && this.riskDataMembers
        //   ? this.riskDataMembers
        //   : this.riskData || [];
        
        // Process risk data into date-indexed format
        const riskByDate = {};
        const recoveryByDate = {};
        const riskFlags = [];
        const recoveryFlags = [];
        
        // If no risk data from Firebase query, try to use store data as fallback
        if (riskSnapshot.size === 0) {
          const storeRiskData = this.modalMemberData['from'] === 'members' && this.riskDataMembers
            ? this.riskDataMembers
            : this.riskData || [];
          
          // Process store risk data in the same format as Firebase data
          storeRiskData.forEach(riskItem => {
            if (riskItem.date) {
              const riskDate = format(new Date(riskItem.date), 'YYYY-MM-DD');
              if (riskDate >= startDate && riskDate <= endDate) {
                const fakeDoc = {
                  data: () => ({
                    date: riskItem.date,
                    risk_level: riskItem.risk_level,
                    risk_due: riskItem.risk_due,
                    highlight: riskItem.highlight,
                    highlightContent: riskItem.highlightContent,
                    status: riskItem.status
                  })
                };
                
                // Process this fake doc the same way as Firebase docs
                const data = fakeDoc.data();
                if (data.date) {
                  const riskDate = format(new Date(data.date), 'YYYY-MM-DD');
                  if (riskDate >= startDate && riskDate <= endDate) {
                    let risk = data.risk_level ? data.risk_level+'R' : ''
                    let highlightContent = data.risk_due?data.risk_due:"Happiness"
                    if(risk){
                      data.highlight=risk=="1R"?"R":risk
                      data.highlight_txt= `${highlightContent}`
                    }
                    // Determine if this is a recovery or risk flag
                    const isRecovery = this.isRecoveryFlag(risk);
                    const content = (data.highlightContent && data.highlightContent !== 'undefined' && data.highlightContent.trim() !== '') 
                      ? data.highlightContent 
                      : (isRecovery ? this.getRecoveryFlagDescription(data.highlight) : this.getRiskFlagDescription(data.highlight));
                    
                    if (isRecovery) {
                      recoveryByDate[riskDate] = {
                        highlight: data.highlight || null,
                        highlightContent: data.highlightContent || null,
                        status: data.status || null
                      };
                    } else {
                      riskByDate[riskDate] = {
                        highlight: data.highlight || null,
                        highlightContent: data.highlightContent || null,
                        status: data.status || null
                      };
                    }
                    
                    if (data.highlight && data.highlight.includes('R')) {
                      const flagData = {
                        date: riskDate,
                        highlight: data.highlight,
                        content: content
                      };
                      
                      if (isRecovery) {
                        recoveryFlags.push(flagData);
                      } else {
                        riskFlags.push(flagData);
                      }
                    }
                  }
                }
              }
            }
          });
        }
        
        riskSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.date) {
            const riskDate = format(new Date(data.date), 'YYYY-MM-DD');
            if (riskDate >= startDate && riskDate <= endDate) {
              let risk = data.risk_level ? data.risk_level+'R' : ''
              let highlightContent = data.risk_due?data.risk_due:"Happiness"
              if(risk){
                data.highlight=risk=="1R"?"R":risk
                data.highlight_txt= `${highlightContent}`
              }
              // Determine if this is a recovery or risk flag
              const isRecovery = this.isRecoveryFlag(risk);
              const content = (data.highlightContent && data.highlightContent !== 'undefined' && data.highlightContent.trim() !== '') 
                ? data.highlightContent 
                : (isRecovery ? this.getRecoveryFlagDescription(data.highlight) : this.getRiskFlagDescription(data.highlight));
              
              if (isRecovery) {
                recoveryByDate[riskDate] = {
                  highlight: data.highlight || null,
                  highlightContent: data.highlightContent || null,
                  status: data.status || null
                };
              } else {
                riskByDate[riskDate] = {
                  highlight: data.highlight || null,
                  highlightContent: data.highlightContent || null,
                  status: data.status || null
                };
              }
              
              if (data.highlight && data.highlight.includes('R')) {
                const flagData = {
                  date: riskDate,
                  highlight: data.highlight,
                  content: content
                };
                
                if (isRecovery) {
                  recoveryFlags.push(flagData);
                } else {
                  riskFlags.push(flagData);
                }
              }
            }
          }
        });
        
        // Process the happiness data
        const happinessData = {};
        const dailyData = [];
        const monthlyData = {}; // Organize by month
        
        // Process Firebase results
        happinessSnapshot.forEach(doc => {
          const data = doc.data();
          const date = data.date;
          
          if (date && typeof data.answer !== 'undefined') {
            let status = 'no-response'; // Default
            
            // Map answer numbers to colors (same as archived version)
            if (data.answer === 0 || data.answer === 1) {
              status = 'green'; // Happy
            } else if (data.answer === 2) {
              status = 'yellow'; // Okay  
            } else if (data.answer === 3 || data.answer === 4) {
              status = 'red'; // Not great
            }
            
            happinessData[date] = status;
          }
        });
        
        // Generate 90-day timeline
        let currentDate = new Date(startDate);
        const endDateObj = new Date(endDate);
        
        let happyDays = 0;
        let okayDays = 0;
        let notGreatDays = 0;
        
        while (currentDate <= endDateObj) {
          const dateStr = format(currentDate, 'YYYY-MM-DD');
          const dayOfWeek = format(currentDate, 'ddd');
          const dayOfMonth = format(currentDate, 'D');
          const monthYear = format(currentDate, 'MMM YYYY');
          const formattedDate = format(currentDate, 'MMM D, YYYY');
          const dayOfWeekNum = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
          
          // Skip weekends (Saturday = 6, Sunday = 0) - no need to check holidays for display
          if (dayOfWeekNum !== 0 && dayOfWeekNum !== 6) {
            const response = happinessData[dateStr];
            
            // Count responses for stats
            if (response && response !== 'no-response') {
              if (response === 'green') happyDays++;
              else if (response === 'yellow') okayDays++;
              else if (response === 'red') notGreatDays++;
            }
            
            // Group by month for calendar display
            if (!monthlyData[monthYear]) {
              monthlyData[monthYear] = {
                monthName: monthYear,
                days: []
              };
            }
            
            // Check for risk flags on this date OR on the weekend before this workday
            let riskFlag = riskByDate[dateStr] || null;
            let recoveryFlag = recoveryByDate[dateStr] || null;
            
            // Check if we need to map weekend risk flags to weekdays
            // If this is Friday, also check for weekend risk flags (Saturday/Sunday) that should appear here
            if (dayOfWeekNum === 5) { // Friday
              const saturday = new Date(currentDate);
              saturday.setDate(saturday.getDate() + 1);
              const sunday = new Date(currentDate);
              sunday.setDate(sunday.getDate() + 2);
              
              const saturdayStr = format(saturday, 'YYYY-MM-DD');
              const sundayStr = format(sunday, 'YYYY-MM-DD');
              
              // Use weekend risk flags if no weekday flag exists
              if (!riskFlag && (riskByDate[saturdayStr] || riskByDate[sundayStr])) {
                riskFlag = riskByDate[saturdayStr] || riskByDate[sundayStr];
              }
              if (!recoveryFlag && (recoveryByDate[saturdayStr] || recoveryByDate[sundayStr])) {
                recoveryFlag = recoveryByDate[saturdayStr] || recoveryByDate[sundayStr];
              }
            }

            monthlyData[monthYear].days.push({
              date: dateStr,
              formattedDate,
              dayOfWeek,
              dayOfMonth,
              response: response || null,
              riskFlag: riskFlag,
              recoveryFlag: recoveryFlag
            });
            
            dailyData.push({
              date: dateStr,
              formattedDate,
              dayOfWeek,
              response: response || null,
              riskFlag: riskFlag,
              recoveryFlag: recoveryFlag
            });
          }
          
          // Move to next day
          currentDate.setDate(currentDate.getDate() + 1);
        }
        
        // Calculate percentages based on total responses (not total days)
        const totalResponseDays = happyDays + okayDays + notGreatDays;
        const happyPercentage = totalResponseDays > 0 ? Math.round((happyDays / totalResponseDays) * 100) : 0;
        const okayPercentage = totalResponseDays > 0 ? Math.round((okayDays / totalResponseDays) * 100) : 0;
        const notGreatPercentage = totalResponseDays > 0 ? Math.round((notGreatDays / totalResponseDays) * 100) : 0;
        
        // Store processed data
        this.$set(this.happinessPatterns, user.email, {
          stats: {
            happyDays,
            okayDays,
            notGreatDays,
            happyPercentage,
            okayPercentage,
            notGreatPercentage,
            totalResponseDays
          },
          dailyData,
          monthlyData,
          raw: happinessData,
          riskFlags: riskFlags, // Risk flag summary
          recoveryFlags: recoveryFlags, // Recovery flag summary
          hasRiskData: riskFlags.length > 0, // Flag to indicate if risk data is available
          hasRecoveryData: recoveryFlags.length > 0 // Flag to indicate if recovery data is available
        });
        
      } catch (error) {
        this.$set(this.happinessPatterns, user.email, { 
          error: `Failed to load data: ${error.message || 'Unknown error'}` 
        });
      } finally {
        this.$set(this.loadingHappinessPatterns, user.email, false);
      }
    },
    /**
     * Get CSS class for risk flag display
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - CSS class name
     */
    getRiskFlagClass(highlight) {
      switch (highlight) {
        case 'R':
          return 'risk-level-1';
        case '2R':
          return 'risk-level-2';
        case '3R':
          return 'risk-level-3';
        default:
          return 'risk-level-1';
      }
    },
    /**
     * Get default description for risk flag if none provided
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - Default risk description
     */
    getRiskFlagDescription(highlight) {
      switch (highlight) {
        case 'R':
          return 'Low risk detected - may need attention';
        case '2R':
          return 'Medium risk detected - needs support';
        case '3R':
          return 'High risk detected - immediate attention needed';
        default:
          return 'Risk detected';
      }
    },
    /**
     * Determine if a risk flag represents a recovery state
     * @param {Object} risk - Risk data object
     * @returns {boolean} - True if this is a recovery flag
     */
    isRecoveryFlag(risk) {
      // Check if status/risk_level indicates recovery (0)
      if (risk.status === 0 || risk.status === '0') {
        return true;
      }
      
      // Check for positive language in highlightContent
      if (risk.highlightContent && typeof risk.highlightContent === 'string') {
        const content = risk.highlightContent.toLowerCase();
        const recoveryKeywords = [
          'encouraging', 'improvement', 'positive', 'recovery', 'better',
          'progress', 'development', 'good place', 'engagement',
          'shifted to more positive', 'observed as the employee'
        ];
        
        return recoveryKeywords.some(keyword => content.includes(keyword));
      }
      
      return false;
    },
    /**
     * Get description for recovery flag display
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - Recovery description
     */
    getRecoveryFlagDescription(highlight) {
      switch (highlight) {
        case 'R':
          return 'Recovery noted - positive engagement observed';
        case '2R':
          return 'Strong recovery - significant improvement detected';
        case '3R':
          return 'Excellent recovery - major positive shift observed';
        default:
          return 'Recovery detected';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.house-seal-image {
  margin: 0px;
  margin-left: 45px;
  width: 90px;
}
.houseSeal_1,
.nullprofileName,
.nullprofileTeamName {
  background-color: #d8d8d8;
}
.houseSeal_1 {
  margin: 0px;
  margin-left: 45px;
  width: 90px;
  height: 110px;
}
.houseSeal_2 {
  margin: 0px;
  margin-left: 45px;
  width: 0;
  height: 0;
  border-left: 45px solid transparent;
  border-right: 45px solid transparent;
  border-top: 45px solid #d8d8d8;
}
.nullprofileName {
  width: 166px;
  height: 25px;
}
.txtProfileName {
  height: 25px;
  font-size: 22px;
  color: #2d2e36;
}
.nullprofileTeamName {
  width: 214px;
  height: 25px;
}
.txtProfileTeamName {
  height: 25px;
  font-size: 16px;
  color: #2d2e36;
}
.img-medal {
  display: block;
  margin: auto;
  width: 42px;
  height: 60px;
}
.curcleUnlock {
  width: 10px;
  height: 10px;
  background: #fbc02d;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  margin-left: 14px;
}
.curcleLock {
  width: 10px;
  height: 10px;
  background: #e9e9e9;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  margin-left: 14px;
}
.rowDataSkillStyle {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 52px;
  opacity: 1;
  background-color: #e9e9e9;
  margin-top: 8px;
}
.flex-column {
  word-break: normal;
}
.icon-close {
  position: absolute;
  right: 60px;
  top: 30px;
  font-size: 30px;
  opacity: 0.8;
  cursor: pointer;
  > i {
    position: fixed;
  }
}
.risk-container {
  background-color: rgba($color: #5f32a7, $alpha: 0.04);
  padding: 2px 16px;
  border-radius: 6px;
  margin: 6px 40px;
  .back-button {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: rgba($color: #000000, $alpha: 0.1);
    margin-right: 6px;
  }
  .risk-line-breaking {
    width: 0px;
    border: 1px solid #a7a7a7;
    border-width: 0 1px 0 0;
    margin: 0 6px 0 12px;
  }
  .risk-status {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: #00000030;
    margin-left: 6px;
    margin-top: 8px;
  }
  .risk-status.none {
    width: 0px;
    height: 0px;
  }
  .risk-status.gray {
    background-color: #00000030;
  }
  .risk-status.green {
    background-color: #66bb6a;
  }
  .risk-status.yellow {
    background-color: #fbc02d;
  }
  .risk-status.red {
    background-color: #f44336;
  }
  .risk-status.holiday {
    background-color: #dbdbdb;
  }
  .relative.last {
    .label {
      position: absolute;
      right: 0px;
      top: 18px;
      color: rgba($color: #000000, $alpha: 0.5);
    }
  }
  .relative > .highlight {
    position: absolute;
    bottom: 14px;
    width: 80px;
    height: 20px;
    left: -10px;
    .pop-up {
      background-color: #6c30cc;
      border-radius: 12px;
      width: 20px;
      height: 20px;
      position: relative;
      &::after {
        position: absolute;
        top: 16px;
        content: "";
        border: 8px solid #6c30cc;
        border-color: #6c30cc transparent transparent transparent;
      }
    }
    .pop-up.risk {
      background-color: #b40303;
      &::after {
        border: 8px solid #b40303;
        border-color: #b40303 transparent transparent transparent;
      }
    }
    .pop-up-red {
      position: absolute;
      background-color: #b40303;
      border-radius: 12px;
      color: #fff;
      padding: 4px 6px 0 0;
      height: calc(20px - 4px);
    }
    .red-1 {
      width: calc(34px - 6px);
    }
    .red-2 {
      width: calc(37px - 6px);
    }
    .red-3 {
      width: calc(40px - 6px);
    }
  }
}
.risk-box-grab {
  height: 92px;
  width: 450px;
  overflow-x: hidden !important;
  overflow-y: hidden !important;

  // Hide scrollbars completely
  &::-webkit-scrollbar {
    display: none;
  }

  // For Firefox
  scrollbar-width: none;

  // For IE
  -ms-overflow-style: none;
}

.max-width-mobile {
  width: 340px;
  margin: auto;
}

.about-me-container {
  border-radius: 0.6rem;
  padding: 12px 16px;
  background-color: rgba($color: #5f32a7, $alpha: 0.04);
  margin: 12px 0;
}

.medals-container {
  border-radius: 0.6rem;
  border: 4px solid #fbb42d;
  background-color: rgba($color: #6c30cc, $alpha: 1);
  margin: 12px 0;
  height: 78px;
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
}

.leaderboards-container {
  width: 100%;
  .box-content {
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    width: calc(100px - 18px);
    height: calc(114px - 24px);
    margin-right: 8px;
    padding: 12px 6px 12px 12px;
    background-color: rgba($color: #ccc, $alpha: 0.2);
    .icons-header {
      background-color: rgba($color: #ccc, $alpha: 1);
      padding: 4px;
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }
  }
  .box-content.recog_count {
    background-color: rgba(102, 187, 106, 0.2);
    .icons-header {
      background-color: rgba(102, 187, 106, 1);
    }
  }
  .box-content.streak_count {
    background-color: rgba(255, 111, 145, 0.2);
    .icons-header {
      background-color: rgba(255, 111, 145, 1);
    }
  }
  .box-content.super_feedback_count {
    background-color: rgba(0, 172, 193, 0.2);
    .icons-header {
      background-color: rgba(0, 172, 193, 1);
    }
  }
  .box-content.ps_initiative_making {
    background-color: rgba(140, 225, 0, 0.2);
    .icons-header {
      background-color: rgba(140, 225, 0, 1);
    }
  }
  .box-content.ps_critical_thinking {
    background-color: rgba(255, 43, 25, 0.2);
    .icons-header {
      background-color: rgba(255, 43, 25, 1);
    }
  }
  .box-content.ps_self_awareness {
    background-color: rgba(247, 117, 17, 0.2);
    .icons-header {
      background-color: rgba(247, 117, 17, 1);
    }
  }
  .box-content.ps_empathy {
    background-color: rgba(96, 0, 218, 0.2);
    .icons-header {
      background-color: rgba(96, 0, 218, 1);
    }
  }
  .box-content.ps_optimism {
    background-color: rgba(242, 210, 34, 0.2);
    .icons-header {
      background-color: rgba(242, 210, 34, 1);
    }
  }
  .box-content.ps_leadership {
    background-color: rgba(0, 170, 26, 0.2);
    .icons-header {
      background-color: rgba(0, 170, 26, 1);
    }
  }
}
.skill-status-container {
  display: grid;
  grid-template-columns: 106px 200px auto;
  margin-bottom: 16px;
  margin-top: 8px;
  gap: 10px;
  align-items: center;
  .label {
    font-size: 13px;
  }
  .status-image {
    display: flex;
    align-items: center;
    justify-content: flex-start !important;
    gap: 2px;
  }
  .icons-text {
    color: #fff;
    font-size: 10px;
    font-weight: 900;
    min-width: 18px;
    padding: 1px 4px;
    text-align: center;
    margin-left: auto;
  }
  .icons-text.top-skill {
    background-color: #00acc1;
    border-radius: 7px;
  }
  .icons-text.culture-add {
    background-color: #5f32a7;
    border-radius: 2px;
  }
}
.ranking {
  background: #FFFFFF;
  border-radius: 50%;
}
.ranking .label {
  line-height: 32px;
  color: #000000;
  font-weight: 500;
}
.view-all {
  cursor: pointer;
  color: #0097a7;
  font-size: 13px;
  font-weight: 500;
}
.divCoin {
  padding-top: 65px;
  padding-right: 30px;
}
.iconCoin {
  width: 32px;
  height: 32px;
  margin-right: 6px;
}
.txtCoin {
  padding-left: 6px;
}
.txtTeam {
  width: auto;
}
.reconigtion-tags-selected {
  font-size: 13px;
  font-weight: 700;
  border:1px solid #00ACC1;
  background-color: #32C2D5;
  border-radius: 21px;
  color: #FFFFFF;
  margin-right: 6px;
  padding: 6px 12px 6px 12px;
  transition: 0.2s;
  border-radius: 21px;
  cursor: default;
}
.reconigtion-tags {
  font-size: 13px;
  font-weight: 400;
  background-color: #FFFFFF;
  border: 1px solid #000000;
  color: #000000;
  margin-right: 6px;
  padding: 6px 12px 6px 12px;
  transition: 0.2s;
  border-radius: 20px;
  cursor: pointer;
  &:hover {
    border:1px solid #00ACC1;
    color: #00ACC1;
    opacity: 1;
  }
}
.personal-context-container {
  background-color: rgba($color: #5f32a7, $alpha: 0.04);
  border-radius: 6px;
  padding: 16px;
  margin: 0 18px;
  max-height: 120px;
  overflow: hidden;
  transition: max-height 0.3s ease;
  
  &.expanded {
    max-height: 1000px;
  }
}
.expand-toggle {
  cursor: pointer;
  color: rgba($color: #000000, $alpha: 0.5);
  transition: color 0.2s ease;
  
  &:hover {
    color: rgba($color: #000000, $alpha: 0.8);
  }
}
.context-section {
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}
.context-label {
  font-size: 12px;
  font-weight: 700;
  color: rgba($color: #000000, $alpha: 0.72);
  margin-bottom: 8px;
}
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.value-tag,
.skill-tag {
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba($color: #5f32a7, $alpha: 0.2);
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #5f32a7;
  white-space: nowrap;
  
  &.needs-improvement {
    background-color: rgba($color: #ff2b19, $alpha: 0.08);
    border-color: rgba($color: #ff2b19, $alpha: 0.2);
    color: #ff2b19;
  }
}
.improvement-indicator {
  margin-left: 4px;
  font-size: 11px;
}
.context-preview {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  .preview-text {
    color: rgba($color: #000000, $alpha: 0.6);
    font-size: 12px;
    font-style: italic;
  }
  
  .view-more {
    color: #0097a7;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
.expanded-content {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba($color: #5f32a7, $alpha: 0.1);
}
.context-text-block {
  background-color: rgba($color: #ffffff, $alpha: 0.6);
  border-radius: 4px;
  padding: 12px;
}
.text-item {
  display: flex;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .text-label {
    font-size: 12px;
    font-weight: 700;
    color: rgba($color: #000000, $alpha: 0.72);
    min-width: 120px;
  }
  
  .text-content {
    font-size: 12px;
    font-weight: 400;
    color: rgba($color: #000000, $alpha: 0.9);
    line-height: 1.4;
  }
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  
  .info-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: rgba($color: #000000, $alpha: 0.8);
    
    i {
      color: #5f32a7;
      font-size: 14px;
    }
    
    &.full-width {
      grid-column: span 2;
    }
  }
}
.challenges-list {
  margin: 0;
  padding-left: 20px;
  
  .challenge-item {
    font-size: 12px;
    color: rgba($color: #000000, $alpha: 0.8);
    line-height: 1.6;
    margin-bottom: 6px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-name-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.personal-context-icon {
  color: #6C30CC;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    color: #6C30CC;
  }
  
  &:hover {
    background-color: rgba(108, 48, 204, 0.1);
    transform: scale(1.1);
  }
}

.profile-photo-container {
  position: relative;
  cursor: pointer;
  
  .photo-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 50%;
    
    i {
      color: white;
      font-size: 24px;
    }
  }
  
  &:hover .photo-overlay {
    opacity: 1;
  }
  
  .profile-photo-clickable {
    transition: transform 0.3s ease;
  }
  
  &:hover .profile-photo-clickable {
    transform: scale(1.05);
  }
}

// Happiness Timeline Icon
.happiness-timeline-icon {
  color: #7C4DFF;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: rgba(124, 77, 255, 0.08);
  
  &:hover {
    color: #5E35B1;
    transform: scale(1.15);
    background-color: rgba(124, 77, 255, 0.15);
  }
}
</style>

<style lang="scss">
#userPreviewDetails {
  .el-tabs__item.is-active,
  .el-tabs__item {
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.72);
    height: 44px;
  }
  .el-tabs__item.is-active {
    color: rgba($color: #000000, $alpha: 1);
    font-weight: 900;
  }
  .el-tabs__active-bar {
    background-color: #13debf !important;
  }
}

// Hide any Element UI dialog close buttons that might interfere
.el-dialog__headerbtn {
  display: none !important;
}

// Custom Photo Modal Styles
.custom-photo-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .photo-modal-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
    color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    
    i {
      font-size: 24px;
    }
    
    &:hover {
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0.7);
      transform: scale(1.1);
    }
  }
  
  .photo-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    
    .fullscreen-photo {
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.4);
    }
    
    .download-button {
      position: absolute;
      bottom: 20px;
      right: 20px;
      background: rgba(0, 0, 0, 0.6);
      color: rgba(255, 255, 255, 0.9);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
      z-index: 5;
      
      i {
        font-size: 18px;
      }
      
      &:hover {
        background: rgba(0, 0, 0, 0.8);
        color: rgba(255, 255, 255, 1);
        transform: scale(1.1);
      }
      
      &:active {
        transform: scale(0.95);
      }
    }
  }
}

// Personal Context Modal Styles
.personal-context-modal {
  border-radius: 16px !important;
  overflow: hidden !important;

  // Let Element UI manage z-index, just ensure our modal is styled correctly
  .el-dialog {
    border-radius: 16px !important;
    overflow: hidden !important;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
                0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
                0px 1.5px 4px rgba(0, 0, 0, 0.015),
                0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
                0px 5px 13.4px rgba(0, 0, 0, 0.022),
                0px 12px 32px rgba(0, 0, 0, 0.03);
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 75vh;
    overflow-y: auto;
    background: #FFFFFF;
    border-radius: 16px !important;

    // Smooth scrolling
    scroll-behavior: smooth;

    // Custom scrollbar styling
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #F5F5F5;
      border-radius: 0 8px 8px 0;
    }

    &::-webkit-scrollbar-thumb {
      background: #D0D0D0;
      border-radius: 4px;

      &:hover {
        background: #B0B0B0;
      }
    }
  }

  .el-dialog__close {
    color: #747474;
    font-size: 20px;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
    transition: color 0.2s ease;

    &:hover {
      color: #000000;
    }
  }
}

.personal-context-content {
  // Apply consistent word breaking to all text content
  word-break: keep-all;
  overflow-wrap: break-word;
  hyphens: none;

  .context-header {
    padding: 32px 32px 20px;
    border-bottom: 1px solid #E8E8E8;
    background: linear-gradient(to bottom, #FAFAFA 0%, #FFFFFF 100%);
    border-radius: 16px 16px 0 0;

    h3 {
      margin: 0 0 6px 0;
      font-size: 20px;
      color: #1A1A1A;
    }

    .context-subtitle {
      margin: 0;
      line-height: 1.6;
      color: #666666;
    }
  }

  .context-section {
    padding: 28px 32px;
    border-bottom: 1px solid #F0F0F0;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #FAFAFA;
    }

    &:last-child {
      border-bottom: none;
    }

    .section-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 18px;

      .section-icon {
        font-size: 18px;
        color: #6C30CC;
        flex-shrink: 0;
      }

      h4 {
        margin: 0;
        font-size: 16px;
        color: #2A2A2A;
        letter-spacing: -0.2px;
      }
    }
  }
  
  .values-container,
  .skills-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .value-tag {
    display: inline-flex;
    align-items: center;
    background-color: rgba(108, 48, 204, 0.08);
    color: #6C30CC;
    padding: 6px 16px;
    border-radius: 16px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid rgba(108, 48, 204, 0.15);
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(108, 48, 204, 0.12);
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(108, 48, 204, 0.15);
    }
  }

  .skill-tag {
    display: inline-flex;
    align-items: center;
    background-color: rgba(26, 195, 98, 0.08);
    color: #1AC362;
    padding: 6px 16px;
    border-radius: 16px;
    font-size: 13px;
    font-weight: 500;
    gap: 4px;
    border: 1px solid rgba(26, 195, 98, 0.15);
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(26, 195, 98, 0.12);
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(26, 195, 98, 0.15);
    }

    &.needs-improvement {
      background-color: rgba(244, 67, 54, 0.08);
      color: #F44336;
      border: 1px solid rgba(244, 67, 54, 0.15);

      &:hover {
        background-color: rgba(244, 67, 54, 0.12);
        box-shadow: 0 2px 6px rgba(244, 67, 54, 0.15);
      }
    }

    i {
      font-size: 12px;
    }
  }

  .goals-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .goal-item {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      padding: 16px;
      background-color: #F8F9FA;
      border-radius: 8px;
      border-left: 3px solid #6C30CC;
      transition: all 0.2s ease;

      &:hover {
        background-color: #F3F4F6;
        transform: translateX(4px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }

      .goal-number {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 28px;
        height: 28px;
        background: linear-gradient(135deg, #6C30CC 0%, #8B5CD6 100%);
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 700;
        border-radius: 50%;
        flex-shrink: 0;
        box-shadow: 0 2px 4px rgba(108, 48, 204, 0.2);
      }

      .goal-text {
        flex: 1;
        line-height: 1.7;
        color: #2A2A2A;
        padding-top: 2px;
      }
    }
  }
  
  .personality-content {
    .content-block {
      margin-bottom: 20px;
      padding: 16px;
      background-color: #FAFAFA;
      border-radius: 6px;
      border: 1px solid #E8E8E8;

      &:last-child {
        margin-bottom: 0;
      }

      .block-label {
        margin-bottom: 10px;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        line-height: 1.4;
        font-size: 11px;
        color: #6C30CC;
        font-weight: 700;
      }

      .block-text {
        line-height: 1.7;
        color: #2A2A2A;
        font-size: 14px;
      }
    }
  }

  .role-content {
    background: linear-gradient(135deg, #F8F9FA 0%, #F3F4F6 100%);
    padding: 18px 20px;
    border-radius: 8px;
    border: 1px solid #E8E8E8;

    div {
      line-height: 1.7;
      color: #2A2A2A;
    }
  }

  .challenges-content {
    .challenge-item {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      margin-bottom: 14px;
      padding: 12px 16px;
      background-color: #FFF8F7;
      border-radius: 6px;
      border-left: 3px solid #F44336;
      transition: all 0.2s ease;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background-color: #FFF3F2;
        transform: translateX(2px);
        box-shadow: 0 2px 6px rgba(244, 67, 54, 0.1);
      }

      .challenge-bullet {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #F44336;
        margin-top: 6px;
        flex-shrink: 0;
        box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.15);
      }

      .challenge-text {
        line-height: 1.7;
        color: #2A2A2A;
      }
    }
  }
}

// Happiness History Tooltip Styles
.happiness-history-tooltip {
  max-width: 380px !important;
  overflow: hidden !important;

  .happiness-loading,
  .happiness-error {
    padding: 12px;
    text-align: center;
    font-size: 13px;
    color: #666;
  }

  .happiness-error {
    color: #f44336;
  }

  .happiness-tooltip-content {
    padding: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    overflow: hidden;
  }
  
  .happiness-tooltip-header {
    margin-bottom: 16px;
    text-align: center;
    
    .tooltip-title {
      font-size: 16px;
      font-weight: 700;
      color: #2d2e36;
      margin-bottom: 4px;
    }
    
    .tooltip-subtitle {
      font-size: 13px;
      color: #666;
    }
  }
  
  .happiness-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 16px;
    
    .stat-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      
      .stat-label {
        color: #666;
        font-weight: 500;
      }
      
      .stat-value {
        color: #2d2e36;
        font-weight: 600;
      }
      
      .stat-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex-shrink: 0;
        
        &.green {
          background-color: #66bb6a;
        }
        
        &.yellow {
          background-color: #fbc02d;
        }
        
        &.red {
          background-color: #f44336;
        }
      }
    }
  }
  
  .happiness-timeline {
    .timeline-label {
      font-size: 12px;
      font-weight: 600;
      color: #666;
      margin-bottom: 8px;
    }

    .timeline-months {
      display: flex;
      flex-direction: column;
      gap: 12px;
      max-height: 240px;
      overflow-y: auto;
      overflow-x: hidden;
      padding-right: 4px;

      // Custom scrollbar styling
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #F5F5F5;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #D0D0D0;
        border-radius: 3px;

        &:hover {
          background: #B0B0B0;
        }
      }
    }

    .timeline-month {
      .month-label {
        font-size: 11px;
        font-weight: 600;
        color: #888;
        margin-bottom: 4px;
        text-align: center;
      }

      .month-grid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 2px;
        justify-items: center;
        width: 100%;
        max-width: 140px;
        margin: 0 auto;
      }
      
      .timeline-day {
        width: 18px;
        height: 18px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        
        .day-number {
          font-size: 9px;
          font-weight: 500;
          color: #333;
        }
        
        &.no-response {
          background-color: #e0e0e0;
          
          .day-number {
            color: #999;
          }
        }
        
        &.green {
          background-color: #66bb6a;
          
          .day-number {
            color: white;
          }
        }
        
        &.yellow {
          background-color: #fbc02d;
          
          .day-number {
            color: #333;
          }
        }
        
        &.red {
          background-color: #f44336;
          
          .day-number {
            color: white;
          }
        }
        
        &:hover {
          transform: scale(1.1);
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
      }
    }
    
    .timeline-legend {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #e0e0e0;
      
      .legend-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 10px;
        color: #666;
        
        .legend-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          
          &.no-response {
            background-color: #e0e0e0;
          }
          
          &.green {
            background-color: #66bb6a;
          }
          
          &.yellow {
            background-color: #fbc02d;
          }
          
          &.red {
            background-color: #f44336;
          }
        }
      }
    }
  }
}

/* Risk Flags Styling */
.risk-flags-summary {
  margin-top: 16px;
  padding: 12px;
  background-color: #fff8f6;
  border-left: 3px solid #f44336;
  border-radius: 4px;
}

.risk-header {
  margin-bottom: 8px;
  
  .risk-title {
    font-size: 12px;
    font-weight: 700;
    color: #d32f2f;
    margin-bottom: 2px;
  }
  
  .risk-subtitle {
    font-size: 10px;
    color: #666;
  }
}

.risk-flags-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.risk-flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  
  .risk-flag-date {
    font-weight: 600;
    color: #333;
    min-width: 60px;
  }
  
  .risk-flag-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 700;
    color: white;
    
    &.risk-level-1 {
      background-color: #ff9800;
    }
    
    &.risk-level-2 {
      background-color: #ff5722;
    }
    
    &.risk-level-3 {
      background-color: #d32f2f;
    }
  }
  
  .risk-flag-content {
    flex: 1;
    color: #666;
    font-size: 9px;
  }
}

.more-flags {
  font-size: 9px;
  color: #999;
  font-style: italic;
  margin-top: 4px;
}

/* Recovery Flags Styling */
.recovery-flags-summary {
  margin-top: 16px;
  padding: 12px;
  background-color: #f1f8f4;
  border-left: 3px solid #4caf50;
  border-radius: 4px;
}

.recovery-header {
  margin-bottom: 8px;
  
  .recovery-title {
    font-size: 12px;
    font-weight: 700;
    color: #2e7d32;
    margin-bottom: 2px;
  }
  
  .recovery-subtitle {
    font-size: 10px;
    color: #666;
  }
}

.recovery-flags-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.recovery-flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  
  .recovery-flag-date {
    font-weight: 600;
    color: #333;
    min-width: 60px;
  }
  
  .recovery-flag-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 700;
    color: white;
    background-color: #4caf50;
    
    &.recovery {
      background-color: #4caf50;
    }
  }
  
  .recovery-flag-content {
    flex: 1;
    color: #666;
    font-size: 9px;
  }
}

/* Risk flag on timeline days */
.timeline-day {
  position: relative;
  
  .risk-flag {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    background-color: #d32f2f;
    color: white;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    z-index: 3;
  }
  
  .recovery-flag {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    background-color: #4caf50;
    color: white;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    z-index: 3;
  }
}
</style>

